import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertyType } from '../../../shared/models/property-type';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-caracteristiques',
  templateUrl: './caracteristiques.component.html',
  styleUrls: ['./caracteristiques.component.scss'],
})
export class CaracteristiquesComponent {
  @Input() characteristics!: Report.Characteristics;
  @Input() propertyType!: PropertyType;
  @Input() isLoading = false;

  characteristicsInternal!: Report.Characteristics;

  @Output() characteristicsChanged = new EventEmitter<Report.Characteristics>();
  @Output() characteristicsEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onCharacteristicsChanged(characteristics: Report.Characteristics): void {
    this.characteristicsInternal = characteristics;
  }

  onSaveSection(): void {
    this.characteristicsChanged.emit(this.characteristicsInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.characteristicsEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
